import React, { useState, useEffect, useRef } from "react";
import editIcon from "./img/edit.png";

import {
   Alert,
   Button,
   Col,
   Form,
   FormCheck,
   FormGroup,
   FormText,
   InputGroup,
   Row,
   Spinner,
   Table,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { emailRegex, header, host, invisiblestring } from "./globalVariables";

import { api, getStaticData } from "./pureFunctions";
import { useConfig } from "./ConfigContext";
import { useAuth } from "./AuthContext";

function mergeUsers(arr1, arr2) {
   const merged = {};
   arr1.forEach((u) => (merged[u.Name] = u));
   arr2.forEach((u) => (merged[u.username] = { ...merged[u.username], ...u }));
   return Object.values(merged);
}
/* 
const abteilungen = { backoffice: "Backoffice",  sonstiges: "Sonstige" }; */
const initValues = {
   file: "",
   username: "",
   nachname: "",
   vorname: "",
   password: "",
   role: "user",
   standort: "",
   abteilung: "",
   description: "",
};

export default function NewImmopilotUser({}) {
   const config = useConfig();
   const { user, setUser } = useAuth();

   const [showPassword, setShowPassword] = useState(false);
   const [userData, setUserData] = useState(initValues);
   const [userList, setUserList] = useState([]);
   const [userListImmopilot, setUserListImmoPilot] = useState([]);
   const [loading, setLoading] = useState(false);
   const [showWarning, setShowWarning] = useState();

   const handleUpload = async (file, name) => {
      try {
         console.log(name);

         const res = await api.post("/api/upload", file, {
            headers: {
               "Content-Type": file.type,
               "X-Filename": name ?? file.name,
            },
         });
         console.log(res.data);
      } catch (err) {
         if (err.response?.status === 401) {
            console.log("Auth-Fehler:", err.response.data.message);
            // z.B. redirect zu /login
         } else {
            console.error("Upload fehlgeschlagen:", err.message);
         }
      }
   };

   useEffect(() => {
      api.get("/api/ip/getImmopilotUsers")
         .then((data) => {
            console.log(data.data);
            setUserListImmoPilot(data.data);
         })
         .catch((err) => {
            console.error(err);
         });

      getStaticData().then((data) => {
         console.log(data);
         setUserList(data[1].userList);
      });
   }, []);

   function isStrongPassword(password) {
      const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_@$!%*?&])[A-Za-z\d_@$!%*?&]{12,}$/;

      return strongPasswordRegex.test(password);
   }

   async function deleteImmopilotUser(username) {
      setLoading("loading");
      await api
         .post("/api/ip/deleteImmopilotUser", { username: username })
         .then((data) => {
            console.log(data);

            if (data.data.rowCount > 0) {
               setUserList((prev) => prev.filter((item) => item.Name !== username));
               setUserListImmoPilot((prev) => prev.filter((item) => item.username !== username));
               setUserData(initValues);
               setLoading(data.status === 200 ? "success" : "error");
            } else {
               setLoading("error");
            }
            setTimeout(() => {
               setLoading(false);
            }, 2000);
         })
         .catch((err) => {
            setLoading("error");

            console.log(err);
         });
   }

   async function updateUserData() {
      setLoading("loading");
      console.log(userData);

      await api
         .post("/api/ip/updateImmopilotUser", userData)
         .then((data) => {
            if (data.status === 200) {
               setUserListImmoPilot((prev) => {
                  let newArr = structuredClone(prev).filter((item) => item.username !== userData.username);
                  newArr.push(userData);
                  return newArr;
               });
               setUserData(initValues);
               setLoading("success");
            } else {
               setLoading("error");
            }
            setTimeout(() => {
               setLoading(false);
            }, 2000);
         })
         .catch((err) => {
            setLoading("error");

            console.log(err);
         });

      if (userData.file) {
         handleUpload(
            userData.file,
            userData.Vorname ? `${userData.Vorname}_${userData.Nachname}.jpg`.replace(" ", "") : false,
         );
      }
   }

   async function sendUserData() {
      setLoading("loading");
      await api
         .post("/api/ip/newImmopilotUser", userData)
         .then((data) => {
            console.log(data);
            if (data.status === 200) {
               setUserListImmoPilot((prev) => [userData, ...prev]);
               setUserData(initValues);
               setLoading("success");
            } else {
               setLoading("error");
            }

            if (userData.file) {
               handleUpload(
                  userData.file,
                  userData.Vorname ? `${userData.Vorname}_${userData.Nachname}.jpg`.replace(" ", "") : false,
               );
            }

            setTimeout(() => {
               setLoading(false);
            }, 2000);
         })
         .catch((err) => {
            setLoading("error");

            console.log(err);
         });
   }
   return (
      <div className="m-5" style={{ position: "relative" }}>
         <h2>Immopilot-Nutzer bearbeiten/anlegen</h2>
         <Form className="m-3">
            <Row>
               <Col xs={12} md={4}>
                  <FormGroup className="mb-3">
                     <Form.Label>Name</Form.Label>
                     <Form.Select
                        disabled={userListImmopilot.map((item) => item.username).includes(userData.username)}
                        autoComplete="off"
                        name="username"
                        className=""
                        onChange={(e) => {
                           setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                        }}
                        value={userData.username}
                     >
                        <option></option>
                        {userList &&
                           userList.length &&
                           userList.map((userItem) => {
                              return <option value={userItem.Name}> {userItem.Name}</option>;
                           })}
                     </Form.Select>
                  </FormGroup>
               </Col>
               {config.company === "baur" && (
                  <Col xs={12} md={4}>
                     <FormGroup className="mb-3">
                        <Form.Label>Name (falls kein onOffice-Nutzer)</Form.Label>
                        <Form.Control
                           autoComplete="off"
                           disabled={userListImmopilot.map((item) => item.username).includes(userData.username)}
                           name="username"
                           className=""
                           onChange={(e) => {
                              setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                           }}
                           value={userData.username}
                        ></Form.Control>
                     </FormGroup>
                  </Col>
               )}
               <Col xs={12} md={2}>
                  <FormGroup className="mb-3">
                     <Form.Label>Bild (Breite: 256px)</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        type="file"
                        name="file"
                        accept=".jpg,.jpeg,image/jpeg"
                        className=""
                        onChange={(e) => {
                           setUserData((prev) => ({ ...prev, [e.target.name]: e.target.files[0] }));
                        }}
                     ></Form.Control>
                  </FormGroup>
               </Col>
               <Col xs={12} md={2} className="text-center">
                  {userData.Vorname && (
                     <img
                        style={{
                           width: 100,
                           height: 100,
                           objectFit: "cover",
                           objectPosition: "0 0",
                           borderRadius: 100,
                           overflow: "hidden",
                           boxShadow: "0 0 10px #0003",
                        }}
                        src={`${host}/images/Mitarbeiter/${encodeURIComponent(userData.Vorname.replace(" ", ""))}_${encodeURIComponent(userData.Nachname.replace(" ", ""))}.jpg`}
                     />
                  )}
               </Col>
            </Row>
            <Row>
               <Col xs={12} md={4}>
                  <FormGroup className="mb-3">
                     <Form.Label>Vorname</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        name="vorname"
                        className=""
                        onChange={(e) => {
                           setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                        }}
                        value={userData.vorname}
                     ></Form.Control>
                  </FormGroup>
               </Col>
               <Col xs={12} md={4}>
                  <FormGroup className="mb-3">
                     <Form.Label>Nachname</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        name="nachname"
                        className=""
                        onChange={(e) => {
                           setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                        }}
                        value={userData.nachname}
                     ></Form.Control>
                  </FormGroup>
               </Col>
            </Row>
            <Row>
               {["globaladmin", "admin"].includes(user?.role) && (
                  <Col xs={12} md={4}>
                     <FormGroup className="mb-3">
                        <Form.Label>Rolle</Form.Label>
                        <Form.Select
                           autoComplete="off"
                           name="role"
                           className=""
                           onChange={(e) => {
                              setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                           }}
                           value={userData.role}
                        >
                           {Object.keys(config.nutzerVerwaltung.roles).map((keyItem) => {
                              return <option value={keyItem}> {config.nutzerVerwaltung.roles[keyItem]}</option>;
                           })}
                        </Form.Select>
                     </FormGroup>
                  </Col>
               )}
               <Col xs={12} md={4}>
                  <FormGroup className="mb-3">
                     <Form.Label>Standort</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        name="standort"
                        className=""
                        onChange={(e) => {
                           setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                        }}
                        value={userData.standort}
                     >
                        <option value="-">-</option>
                        {Object.keys(config.standorte)
                           .filter((item) => !config.standorte[item].fake)
                           .map((keyItem) => {
                              return <option value={keyItem}> {keyItem}</option>;
                           })}
                     </Form.Select>
                  </FormGroup>
               </Col>
               <Col xs={12} md={4}>
                  <FormGroup className="mb-3">
                     <Form.Label>Abteilung</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        name="abteilung"
                        className=""
                        onChange={(e) => {
                           setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                        }}
                        value={userData.abteilung}
                     >
                        <option value="-">-</option>
                        {Object.keys(config.nutzerVerwaltung.abteilungen).map((keyItem) => {
                           return <option value={keyItem}> {config.nutzerVerwaltung.abteilungen[keyItem]}</option>;
                        })}
                     </Form.Select>
                  </FormGroup>
               </Col>
            </Row>
            <Row>
               <Col xs={12} md={4}>
                  <FormGroup as={Col} className="mb-3">
                     <Form.Label>Beschreibung</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        name="description"
                        className=""
                        onChange={(e) => {
                           setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                        }}
                        value={userData.description}
                     ></Form.Control>
                  </FormGroup>
               </Col>
            </Row>
            <Row>
               {userData.notifications &&
                  Object.keys(userData.notifications).map((notKey) => {
                     return (
                        <div>
                           <strong>{notKey}</strong>
                           <ol>
                              {userData.notifications[notKey].map((notItem) => {
                                 return <li>{JSON.stringify(notItem)}</li>;
                              })}
                           </ol>
                        </div>
                     );
                  })}
            </Row>
            {["globaladmin", "admin"].includes(user?.role) && (
               <Row>
                  <Col xs={12} md={8}>
                     <FormGroup className="mb-3">
                        <Form.Label>Passwort</Form.Label>

                        <Form.Control
                           autoComplete="new-password"
                           type={showPassword ? "text" : "password"}
                           name="password"
                           className=""
                           style={
                              userData.password
                                 ? isStrongPassword(userData.password)
                                    ? {}
                                    : { border: "solid 2px #f00" }
                                 : {}
                           }
                           onChange={(e) => {
                              setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                           }}
                           value={userData.password}
                        />
                        <FormText>
                           (mind. 12 Zeichen, Groß- und Kleinschreibung, Zahl und Sonderzeichen zB. _@$!%*?& )
                        </FormText>
                     </FormGroup>
                  </Col>
                  <Col xs={12} md={4}>
                     <FormGroup className="mb-3">
                        <Form.Label>Passwort anzeigen</Form.Label>
                        <Form.Check
                           onChange={(e) => {
                              setShowPassword(e.target.checked);
                           }}
                           type="checkbox"
                           id={`disabled-default-${""}`}
                        />
                     </FormGroup>
                  </Col>
               </Row>
            )}
            {loading === "loading" && (
               <div>
                  <Spinner></Spinner>
               </div>
            )}
            {loading === "success" && <Alert variant="success">Erfolg!</Alert>}
            {loading === "error" && <Alert variant="danger">Fehlgeschlagen!</Alert>}
            {userListImmopilot.map((item) => item.username).includes(userData.username) ? (
               <>
                  {showWarning ? (
                     <div className="text-end">
                        <Alert className="text-start" variant="danger">
                           <h4 className="mb-3">Nutzer wirklich entfernen?</h4>
                           <div>
                              <Button
                                 onClick={() => {
                                    setShowWarning(false);
                                 }}
                              >
                                 Abbrechen
                              </Button>

                              <Button
                                 variant="danger"
                                 className="ms-2"
                                 onClick={async () => {
                                    await deleteImmopilotUser(userData.username);
                                    setShowWarning(false);
                                 }}
                              >
                                 Ja, endgültig löschen
                              </Button>
                           </div>
                        </Alert>
                     </div>
                  ) : (
                     <>
                        <Button
                           variant="primary"
                           className="me-2"
                           disabled={userData.password && !isStrongPassword(userData.password)}
                           onClick={() => {
                              updateUserData();
                           }}
                        >
                           Änderungen speichern
                        </Button>
                        <Button
                           className="me-2"
                           variant="secondary"
                           onClick={() => {
                              setUserData(initValues);
                           }}
                        >
                           Abbrechen
                        </Button>
                        {["globaladmin", "admin"].includes(user?.role) && (
                           <Button
                              variant="warning"
                              onClick={() => {
                                 setShowWarning(true);
                              }}
                           >
                              Nutzer entfernen
                           </Button>
                        )}
                     </>
                  )}
               </>
            ) : (
               <Button
                  onClick={() => {
                     sendUserData();
                  }}
                  disabled={
                     !(userData.username && userData.password && isStrongPassword(userData.password)) ||
                     loading === "loading"
                  }
               >
                  Neuen Nutzer anlegen
               </Button>
            )}
         </Form>

         <div className="mt-5">
            <h2>Aktuelle Nutzer</h2>
            <Table striped bordered hover responsive>
               <thead>
                  <tr>
                     {/* <th> </th> */}
                     <th></th>
                     <th>Nachname</th>
                     <th>Vorname</th>
                     <th>oO-Id</th>
                     <th>oO-Username</th>
                     <th>oO-Kürzel</th>
                     <th>Rolle</th>
                     <th>Standort</th>
                     <th>Abteilung</th>
                     <th>Beschreibung</th>
                     <th>Benachrichtigungen</th>
                  </tr>
               </thead>
               <tbody>
                  {mergeUsers(userList, userListImmopilot)
                     .sort((a, b) => (a.Nachname > b.Nachname ? 1 : -1))
                     .map((item, index) => {
                        return (
                           <tr key={index}>
                              {/* <td className="text-center">{index + 1}</td> */}
                              <td className="text-center" title="bearbeiten">
                                 <Button
                                    variant="outline-dark"
                                    onClick={() => {
                                       window.scrollTo({ top: 0, behavior: "smooth" });
                                       setUserData({
                                          vorname: item.vorname ?? item.Vorname,
                                          nachname: item.nachname ?? item.Nachname,
                                          username: item.Name ?? item.username,
                                          password: "",
                                          role: item.role,
                                          standort: item.standort ?? "",
                                          abteilung: item.abteilung ?? "",
                                          notifications: item.notifications ?? null,
                                       });
                                    }}
                                 >
                                    <img src={editIcon} height={16} />
                                 </Button>
                              </td>
                              <td className="text-center">{item.nachname ?? item.Nachname}</td>
                              <td className="text-center">{item.vorname ?? item.Vorname}</td>

                              <td className="text-center">{item.id}</td>

                              <td className="text-center">{item.username ?? item.Name}</td>
                              <td className="text-center">{item.Kuerzel}</td>

                              <td className="text-start" style={{ maxWidth: 60, overflow: "hidden" }}>
                                 {config.nutzerVerwaltung.roles[item.role] ?? item.role}
                              </td>
                              <td className="text-center">{item.standort ?? ""}</td>
                              <td className="text-center">
                                 {item.abteilung ? config.nutzerVerwaltung.abteilungen[item.abteilung] : ""}
                              </td>
                              <td>{item.description}</td>
                              <td
                                 title={JSON.stringify(item.notifications)}
                                 style={{ maxWidth: "100px", overflow: "auto" }}
                              >
                                 {item.notifications && Object.values(item.notifications)?.flat()?.length}
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </Table>
         </div>
      </div>
   );
}
